import Button from '@global/Button'
import IconFile from '@global/Icons/File'
import { adfenix } from '@lib/adfenixHelper'

const StatementOfInformation = ({ documents }) => {
  const doc = documents?.find(
    (it) =>
      it.name?.toLowerCase() === 'statement of information' ||
      it.name?.toLowerCase() === 'statementofinformation' ||
      it.name?.toLowerCase() === 'property price statement' ||
      it.name?.toLowerCase() === 'propertypricestatement'
  )

  return doc ? (
    <a
      href={doc.file}
      target='_blank'
      onClick={() => adfenix.downloadinfoclick()}
    >
      <Button border startIcon={<IconFile />} color='primary' size='sm'>
        Property Price Statement
      </Button>
    </a>
  ) : null
}

export default StatementOfInformation
